"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebVitalsInstrumentation = exports.InstrumentationAbstract = void 0;
const attribution_1 = require("web-vitals/attribution");
const version_1 = require("./version");
const api_1 = require("@opentelemetry/api");
const shimmer = __importStar(require("shimmer"));
// To avoid importing InstrumentationAbstract from:
// import { InstrumentationAbstract } from '@opentelemetry/instrumentation/build/src/instrumentation';
// When this is exposed we can import from there.
class InstrumentationAbstract {
    constructor(instrumentationName, instrumentationVersion, config = {}) {
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        /* Api to wrap instrumented method */
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this._wrap = shimmer.wrap;
        /* Api to unwrap instrumented methods */
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this._unwrap = shimmer.unwrap;
        /* Api to mass wrap instrumented method */
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this._massWrap = shimmer.massWrap;
        /* Api to mass unwrap instrumented methods */
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this._massUnwrap = shimmer.massUnwrap;
        this._config = Object.assign({ enabled: true }, config);
        this._diag = api_1.diag.createComponentLogger({
            namespace: instrumentationName,
        });
        this._tracer = api_1.trace.getTracer(instrumentationName, instrumentationVersion);
        this._meter = api_1.metrics.getMeter(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Returns meter */
    get meter() {
        return this._meter;
    }
    /**
     * Sets MeterProvider to this plugin
     * @param meterProvider
     */
    setMeterProvider(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    }
    /**
     * Sets the new metric instruments with the current Meter.
     */
    _updateMetricInstruments() {
        return;
    }
    /* Returns InstrumentationConfig */
    getConfig() {
        return this._config;
    }
    /**
     * Sets InstrumentationConfig to this plugin
     * @param InstrumentationConfig
     */
    setConfig(config = {}) {
        this._config = Object.assign({}, config);
    }
    /**
     * Sets TraceProvider to this plugin
     * @param tracerProvider
     */
    setTracerProvider(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    }
    /* Returns tracer */
    get tracer() {
        return this._tracer;
    }
}
exports.InstrumentationAbstract = InstrumentationAbstract;
/**
 * Web vitals auto-instrumentation, sends spans automatically for CLS, LCP, INP, FCP, FID, TTFB.
 * Defaults to sending spans for CLS, LCP, INP, FCP and TTFB.
 * @param config The {@link WebVitalsInstrumentationConfig }
 */
class WebVitalsInstrumentation extends InstrumentationAbstract {
    constructor({ enabled = true, vitalsToTrack = ['CLS', 'LCP', 'INP'], lcp, cls, inp, fid, fcp, ttfb, } = {}) {
        const config = {
            enabled,
            vitalsToTrack,
            lcp,
            cls,
            inp,
            fid,
            fcp,
            ttfb,
        };
        super('@honeycombio/instrumentation-web-vitals', version_1.VERSION, config);
        this.onReportCLS = (cls, applyCustomAttributes) => {
            if (!this.isEnabled())
                return;
            const { name, attribution } = cls;
            const { largestShiftTarget, largestShiftTime, largestShiftValue, loadState, largestShiftEntry, } = attribution;
            const attrPrefix = this.getAttrPrefix(name);
            const span = this.tracer.startSpan(name);
            span.setAttributes(Object.assign(Object.assign({}, this.getSharedAttributes(cls)), { [`${attrPrefix}.largest_shift_target`]: largestShiftTarget, [`${attrPrefix}.element`]: largestShiftTarget, [`${attrPrefix}.largest_shift_time`]: largestShiftTime, [`${attrPrefix}.largest_shift_value`]: largestShiftValue, [`${attrPrefix}.load_state`]: loadState, [`${attrPrefix}.had_recent_input`]: largestShiftEntry === null || largestShiftEntry === void 0 ? void 0 : largestShiftEntry.hadRecentInput }));
            if (applyCustomAttributes) {
                applyCustomAttributes(cls, span);
            }
            span.end();
        };
        this.onReportLCP = (lcp, applyCustomAttributes) => {
            if (!this.isEnabled())
                return;
            const { name, attribution } = lcp;
            const { element, url, timeToFirstByte, resourceLoadDelay, resourceLoadDuration, elementRenderDelay, } = attribution;
            const attrPrefix = this.getAttrPrefix(name);
            const span = this.tracer.startSpan(name);
            span.setAttributes(Object.assign(Object.assign({}, this.getSharedAttributes(lcp)), { [`${attrPrefix}.element`]: element, [`${attrPrefix}.url`]: url, [`${attrPrefix}.time_to_first_byte`]: timeToFirstByte, [`${attrPrefix}.resource_load_delay`]: resourceLoadDelay, [`${attrPrefix}.resource_load_duration`]: resourceLoadDuration, [`${attrPrefix}.element_render_delay`]: elementRenderDelay, 
                // This will be deprecated in a future version
                [`${attrPrefix}.resource_load_time`]: resourceLoadDuration }));
            if (applyCustomAttributes) {
                applyCustomAttributes(lcp, span);
            }
            span.end();
        };
        this.onReportINP = (inp, applyCustomAttributes) => {
            if (!this.isEnabled())
                return;
            const { name, attribution } = inp;
            const { inputDelay, interactionTarget, interactionTime, interactionType, loadState, nextPaintTime, presentationDelay, processingDuration, } = attribution;
            const attrPrefix = this.getAttrPrefix(name);
            const span = this.tracer.startSpan(name);
            span.setAttributes(Object.assign(Object.assign({}, this.getSharedAttributes(inp)), { [`${attrPrefix}.input_delay`]: inputDelay, [`${attrPrefix}.interaction_target`]: interactionTarget, [`${attrPrefix}.interaction_time`]: interactionTime, [`${attrPrefix}.interaction_type`]: interactionType, [`${attrPrefix}.load_state`]: loadState, [`${attrPrefix}.next_paint_time`]: nextPaintTime, [`${attrPrefix}.presentation_delay`]: presentationDelay, [`${attrPrefix}.processing_duration`]: processingDuration, 
                // These will be deprecated in a future version
                [`${attrPrefix}.element`]: interactionTarget, [`${attrPrefix}.event_type`]: interactionType }));
            if (applyCustomAttributes) {
                applyCustomAttributes(inp, span);
            }
            span.end();
        };
        this.onReportFCP = (fcp, applyCustomAttributes) => {
            if (!this.isEnabled())
                return;
            const { name, attribution } = fcp;
            const { timeToFirstByte, firstByteToFCP, loadState } = attribution;
            const attrPrefix = this.getAttrPrefix(name);
            const span = this.tracer.startSpan(name);
            span.setAttributes(Object.assign(Object.assign({}, this.getSharedAttributes(fcp)), { [`${attrPrefix}.time_to_first_byte`]: timeToFirstByte, [`${attrPrefix}.time_since_first_byte`]: firstByteToFCP, [`${attrPrefix}.load_state`]: loadState }));
            if (applyCustomAttributes) {
                applyCustomAttributes(fcp, span);
            }
            span.end();
        };
        /**
         *  @deprecated this will be removed in the next major version, use INP instead.
         */
        this.onReportFID = (fid, applyCustomAttributes) => {
            if (!this.isEnabled())
                return;
            const { name, attribution } = fid;
            const { eventTarget, eventType, loadState } = attribution;
            const attrPrefix = this.getAttrPrefix(name);
            const span = this.tracer.startSpan(name);
            span.setAttributes(Object.assign(Object.assign({}, this.getSharedAttributes(fid)), { [`${attrPrefix}.element`]: eventTarget, [`${attrPrefix}.event_type`]: eventType, [`${attrPrefix}.load_state`]: loadState }));
            if (applyCustomAttributes) {
                applyCustomAttributes(fid, span);
            }
            span.end();
        };
        this.onReportTTFB = (ttfb, applyCustomAttributes) => {
            if (!this.isEnabled())
                return;
            const { name, attribution } = ttfb;
            const { cacheDuration, connectionDuration, dnsDuration, requestDuration, waitingDuration, } = attribution;
            const attrPrefix = this.getAttrPrefix(name);
            const span = this.tracer.startSpan(name);
            span.setAttributes(Object.assign(Object.assign({}, this.getSharedAttributes(ttfb)), { [`${attrPrefix}.waiting_duration`]: waitingDuration, [`${attrPrefix}.dns_duration`]: dnsDuration, [`${attrPrefix}.connection_duration`]: connectionDuration, [`${attrPrefix}.request_duration`]: requestDuration, [`${attrPrefix}.cache_duration`]: cacheDuration, 
                // These will be deprecated ina future version
                [`${attrPrefix}.waiting_time`]: waitingDuration, [`${attrPrefix}.dns_time`]: dnsDuration, [`${attrPrefix}.connection_time`]: connectionDuration, [`${attrPrefix}.request_time`]: requestDuration }));
            if (applyCustomAttributes) {
                applyCustomAttributes(ttfb, span);
            }
            span.end();
        };
        this.vitalsToTrack = [...vitalsToTrack];
        this.lcpOpts = lcp;
        this.clsOpts = cls;
        this.inpOpts = inp;
        this.fidOpts = fid;
        this.fcpOpts = fcp;
        this.ttfbOpts = ttfb;
        this._isEnabled = enabled;
        this._setupWebVitalsCallbacks();
    }
    init() { }
    _setupWebVitalsCallbacks() {
        if (this.vitalsToTrack.includes('CLS')) {
            (0, attribution_1.onCLS)((vital) => {
                var _a;
                this.onReportCLS(vital, (_a = this.clsOpts) === null || _a === void 0 ? void 0 : _a.applyCustomAttributes);
            }, this.clsOpts);
        }
        if (this.vitalsToTrack.includes('LCP')) {
            (0, attribution_1.onLCP)((vital) => {
                var _a;
                this.onReportLCP(vital, (_a = this.lcpOpts) === null || _a === void 0 ? void 0 : _a.applyCustomAttributes);
            }, this.lcpOpts);
        }
        if (this.vitalsToTrack.includes('INP')) {
            (0, attribution_1.onINP)((vital) => {
                var _a;
                this.onReportINP(vital, (_a = this.inpOpts) === null || _a === void 0 ? void 0 : _a.applyCustomAttributes);
            }, this.inpOpts);
        }
        if (this.vitalsToTrack.includes('FID')) {
            (0, attribution_1.onFID)((vital) => {
                var _a;
                this.onReportFID(vital, (_a = this.fidOpts) === null || _a === void 0 ? void 0 : _a.applyCustomAttributes);
            }, this.fidOpts);
        }
        if (this.vitalsToTrack.includes('TTFB')) {
            (0, attribution_1.onTTFB)((vital) => {
                var _a;
                this.onReportTTFB(vital, (_a = this.ttfbOpts) === null || _a === void 0 ? void 0 : _a.applyCustomAttributes);
            }, this.ttfbOpts);
        }
        if (this.vitalsToTrack.includes('FCP')) {
            (0, attribution_1.onFCP)((vital) => {
                var _a;
                this.onReportFCP(vital, (_a = this.fcpOpts) === null || _a === void 0 ? void 0 : _a.applyCustomAttributes);
            }, this.fcpOpts);
        }
    }
    getAttrPrefix(name) {
        return name.toLowerCase();
    }
    getSharedAttributes(vital) {
        const { name, id, delta, rating, value, navigationType } = vital;
        const attrPrefix = this.getAttrPrefix(name);
        return {
            [`${attrPrefix}.id`]: id,
            [`${attrPrefix}.delta`]: delta,
            [`${attrPrefix}.value`]: value,
            [`${attrPrefix}.rating`]: rating,
            [`${attrPrefix}.navigation_type`]: navigationType,
        };
    }
    disable() {
        if (!this.isEnabled()) {
            this._diag.debug(`Instrumentation already disabled`);
            return;
        }
        this._isEnabled = false;
        this._diag.debug(`Instrumentation  disabled`);
    }
    enable() {
        if (this.isEnabled()) {
            this._diag.debug(`Instrumentation already enabled`);
            return;
        }
        this._isEnabled = true;
        this._diag.debug(`Instrumentation  enabled`);
        this._diag.debug(`Sending spans for ${this.vitalsToTrack.join(',')}`);
    }
    isEnabled() {
        return this._isEnabled;
    }
}
exports.WebVitalsInstrumentation = WebVitalsInstrumentation;
